import React from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import _ from 'lodash';
import './App.css';

import Report from './containers/report';
import ReportView from './containers/report-view';
import SuperReport from './containers/super-report';
import Shortlist from './containers/shortlist';
import ShortlistV2 from './containers/shortlist-v2';
import ShortlistV3 from './containers/shortlist-v3';
import CampaignReport from './containers/campaign-report';
import CampaignReport2 from './containers/campaign-report2';
import StoriesReport from './containers/stories-report';
import CorqLogin from './components/corq-login';
import Profile from './containers/profile';
import Summary from './containers/summary';
import ProfileList from './containers/profile-list';

const GO_BLUE_42_DOMAIN = 'reports.goblue42.com';
const CORQ_DOMAIN = 'share.corq.studio';
const DORCHESTER_DOMAIN = 'share.dorchestercollection.com';
const THE_INFLUENCER_DOMAIN = 'share.contentclub.es';
const THE_ROOM_DOMAIN = 'reports.theroom.io';
const STYLIST_DOMAIN = 'reports.stylist.co.uk';
const SUFORIA_DOMAIN = 'share.suforia.com';
const CPA_DOMAIN = 'share.crowdpointanalytics.com';
const BDS_DOMAIN = 'brandfluencersanalytics.bdsmktg.com';
const INFLUXER_DOMAIN = 'brands.influxer.co.uk';
const INCAST_DOMAIN = 'shareable.incast.us';
const UPLOAD_DOMAIN = 'share.uploadagency.com';
const INSPACE_DOMAIN = 'share-influencer.inspace.asia';
const GIFTA_DOMAIN = 'share.gifta.co.uk';
const PULSE_DOMAIN = 'share.pulse.africa';
const INFLUXCROWD_DOMAIN = 'share.influxcrowd.com';
const FREEFOLK_DOMAIN = 'share.freefolkagency.com';
const BROADWAY_DOMAIN = 'reports.broadwaysocial.media';
const MOONBOOTS_DOMAIN = 'share.mymoonboots.io';
const PARENTSTARS_DOMAIN = 'share.parentstars.co.uk';
const GENFLUENCER_DOMAIN = 'share.genfluencer.io';
const MINFLU_DOMAIN = 'share.mingpoapp.dk';
const MECINC_DOMAIN = 'share.mecinc.gg';
const FLYT_DOMAIN = 'share.flytexperience.com';
const SNACKDRAWER_DOMAIN = 'share.snackdrawer.com';
const GLOBALMEDIA_DOMAIN = 'reports.global-media.gr';
const ROOMUNLOCKED_DOMAIN = 'reports.roomunlocked.com';
const SENDY_DOMAIN = 'reports.sendy.io';
const ABBOTTLYON_DOMAIN = 'reporting.abbottlyon.com';
const MONUMENTAL_DOMAIN = 'reports.monumentalmarketing.co.uk';
const TOPTRUMPS_DOMAIN = 'share.toptrumps.com';
const EMBELLISHEDLONDON_DOMAIN = 'share.embellishedlondon.com';
const THEINFLUENCEROOM_DOMAIN = 'reports.theinfluenceroom.com';
const WEFLUENS_DOMAIN = 'share.wefluens.com';
const SHOPFLUENCE_DOMAIN = 'share.shopfluence.app';
const STARBOX_DOMAIN = 'share.starbox.co.uk';
const SEHO_DOMAIN = 'share.seho.app';
const CAMPFIRE_DOMAIN = 'share.campfire.co.uk';
const ELEMIS_DOMAIN = 'share.elemis.com';
const MSQ_DOMAIN = 'share.msqpartners.com';
const LANGTON_DOMAIN = 'reports.langtonpr.com';
const DREAMLAB_DOMAIN = 'reports.dreamlabstudio.co.uk';
const SHELLRIMULA_DOMAIN = 'shellreports.msqpartners.com';
const WILDFUSION_DOMAIN = 'share.wildfusions.com';
const NOVAI_DOMAIN = 'reports.novaiinfluencer.ai';
const SCREENSHOT_DOMAIN = 'share.screenshotmedia.co';

if (module.hot) {
  module.hot.accept();
}

const Home = () => (
  <div>
    <h2>Home</h2>
  </div>
);

const Shortlists = ({ match }) => (
  <div>
    <Route path={`${match.url}/:shortlistId`} component={Shortlist} />
    <Route
      exact path={match.url} render={() => (
        <h3>No shortlists for you!</h3>
      )}
    />
  </div>
);

const ShortlistsV2 = ({ match }) => (
  <div>
    <Route path={`${match.url}/:shortlistId`} component={ShortlistV2} />
    <Route
      exact path={match.url} render={() => (
        <h3>No shortlists for you!</h3>
      )}
    />
  </div>
);

const ShortlistsV3 = ({ match }) => (
  <div>
    <Route path={`${match.url}/:shortlistId`} component={ShortlistV3} />
    <Route
      exact path={match.url} render={() => (
        <h3>No shortlists for you!</h3>
      )}
    />
  </div>
);

const tcStyles = { textAlign: 'center', padding: 10 };
const { hostname } = window.location;
const SUBDOMAIN = _.split(hostname, '.')[0];
console.log(`SD => ${SUBDOMAIN}`);

const SKINS = {
  disruptr: {
    backgroundColor: '#ffd200',
    borderBottom: '2px solid #000',
  },
  voxogramr: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #BF0000',
  },
  marshallr: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
  },
  vizzr: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
  },
  travlrrr: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
  },
  kin: {
    backgroundColor: '#0d1b2d',
    borderBottom: '2px solid #000',
  },
  pgoner: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
  },
  bmbr: {
    backgroundColor: '#000',
    borderBottom: '2px solid #000',
  },
  afterpartyr: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
    textAlign: 'center',
    height: 120,
  },
  stylistr: {
    backgroundColor: '#FFF',
    borderBottom: '3px solid #3dd2be',
    height: 70,
  },
  lacajar: {
    backgroundColor: '#FFF',
    borderBottom: '3px solid #ff0093',
    height: 70,
  },
  marmalader: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
    height: 70,
  },
  influxerr: {
    backgroundColor: '#000',
    borderBottom: '2px solid #000',
    height: 50,
  },
  uploadr: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #ef2a30',
    height: 60,
  },
  addfluencer: {
    backgroundImage: 'linear-gradient(to right, #f373a1, #ff9f1e)',
    borderBottom: '2px solid #000',
  },
  giftar: {
    backgroundColor: '#CC6CE7',
    borderBottom: '2px solid #CC6CE7',
    height: 80,
  },
  inspacer: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #FEC909',
    height: 60,
  },
  flytr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #101010',
    height: 80,
  },
  moir: {
    backgroundColor: '#fff',
    borderBottom: '4px solid rgb(111 111 111)',
    height: 60,
  },
  rightlanderr: {
    backgroundColor: '#0057bc',
    borderBottom: '4px solid rgb(111 111 111)',
    height: 60,
  },
  pulser: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #AB2923',
    height: 80,
  },
  influxcrowdr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #ED0444',
    height: 80,
  },
  ntwr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #E94E1A',
    height: 60,
  },
  freefolkr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #526e81',
  },
  broadwayr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #d472c3',
    height: 60,
  },
  moonbootsr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #000000',
    height: 60,
  },
  parentstarsr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #302c6b',
    height: 60,
  },
  genfluencerr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #CCFF33',
    height: 60,
  },
  mingoAppr: {
    backgroundColor: '#fff',
    borderBottom: '4px solid  #03A8C2',
    height: 60,
  },
  agent99r: {
    backgroundColor: '#fff',
    borderBottom: '4px solid  #000',
    height: 60,
  },
  sportendorse: {
    backgroundColor: '#0185b6',
    borderBottom: '4px solid #0185b6',
    height: 60,
  },
  lineupr: {
    backgroundColor: '#000',
    borderBottom: '2px solid #000',
    height: 60,
  },
  sweatcoinr: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #001430',
    height: 60,
  },
  monumentalr: {
    backgroundColor: '#F2E3AB',
    borderBottom: '2px solid #000',
    height: 80,
  },
  kemosaber: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 60,
  },
  msqsourcer: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #0000eb',
    height: 60,
  },
  wrenr: {
    backgroundColor: '#26a85d',
    borderBottom: '4px solid #26a85d',
    height: 60,
  },
  underarmourr: {
    backgroundColor: '#FFF',
    borderBottom: '3px solid #000',
    height: 70,
  },
  allwynr: {
    backgroundColor: '#FFF',
    borderBottom: '3px solid #000',
    height: 70,
  },
  localhost: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #0000eb',
    height: 60,
  },
};

const isDyzio = (hostname === 'share.dyzio.co' || hostname === 'reports.dyzio.co');
const isVoxogram = (hostname === 'app.voxogram.com');
const termsAndConditionsLink = isVoxogram
  ? 'https://www.voxogram.com/terms-and-conditions'
  : 'https://dyzio.co/terms-of-use';

const isAfterParty = SUBDOMAIN === 'afterpartyr';

const ShareHeader = () => (
  <div>
    <h1>
      {
        isDyzio ?
          <a href="https://dyzio.co" target="_blank" rel="noopener noreferrer">
            <img
              src="/images/logo.svg"
              height="40" alt="dyzio"
            />
          </a>
          :
          <a href={`https://${SUBDOMAIN}.dyzio.co`} target="_blank" rel="noopener noreferrer">
            <img
              src={`/images/${SUBDOMAIN}-logo.png`}
              height={isAfterParty ? 100 : 40} alt={`${SUBDOMAIN}`}
            />
          </a>
      }
    </h1>
  </div>
);

const VoxogramHeader = () => (
  <div>
    <h1>
      <a href="https://app.voxogram.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://app.voxogram.com/themes/theme/voxogram/logo.png"
          height="40" alt="voxogram"
        />
      </a>
    </h1>
  </div>
);

const GB42Header = () => (
  <div>
    <h1>
      <a href="https://influencers.goblue42.com" target="_blank" rel="noopener noreferrer">
        <img
          src="/images/gb42-logo.png"
          height="90" alt="BLUE 42 Agency"
        />
      </a>
    </h1>
  </div>
);

const CorqHeader = () => (
  <div>
    <h1>
      <a href="https://data.corq.studio" target="_blank" rel="noopener noreferrer">
        <img
          src="https://data.corq.studio/themes/theme/corq/corq-logo.svg"
          height="50" alt="CORQ Agency"
        />
      </a>
    </h1>
  </div>
);


const TheInfluencerHeader = () => (
  <div>
    <h1 style={{ paddingTop: 5 }}>
      <a href="https://data.contentclub.es" target="_blank" rel="noopener noreferrer">
        <img
          src="https://data.contentclub.es/themes/theme/the-influencer/logo.png"
          height="60" alt="Content Club"
        />
      </a>
    </h1>
  </div>
);

const DorchesterHeader = () => (
  <div>
    <h1>
      <a href="https://creators.dorchestercollection.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.dorchestercollection.com/themes/theme/dc/dc-logo.png"
          height="70" alt="Dorchester Collection Creators"
        />
      </a>
    </h1>
  </div>
);

const TheRoomHeader = () => (
  <div>
    <h1>
      <a href="https://campaigns.theroom.io" target="_blank" rel="noopener noreferrer">
        <img
          src="https://campaigns.theroom.io/themes/theme/theroom/theroom-dark.png"
          height="70" alt="THE INFLUENCE ROOM | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const StylistHeader = () => (
  <div>
    <h1>
      <a href="https://campaigns.stylist.co.uk" target="_blank" rel="noopener noreferrer">
        <img
          src="https://campaigns.stylist.co.uk/themes/theme/stylist/stylist-dark.png"
          height="70" alt="STYLIST | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const CpaHeader = () => (
  <div>
    <h1>
      <a href="https://tracking.crowdpointanalytics.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://tracking.crowdpointanalytics.com/themes/theme/crowdpointanalytics/cpa-horizontal-full.png"
          height="70" alt="CROWDPOINT ANALYTICS | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const SuforiaHeader = () => (
  <div>
    <h1>
      <a href="https://data.suforia.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://data.suforia.com/themes/theme/suforia/suforia-white-text.png"
          height="60" alt="SUFORIA | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const BdsHeader = () => (
  <div>
    <h1>
      <a href="https://brandfluencers.bdsmktg.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://brandfluencers.bdsmktg.com/themes/theme/bds/logo.png"
          height="60" alt="Brandfluencers | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const InfluxerHeader = () => (
  <div>
    <h1>
      <a href="https://creators.influxer.co.uk" target="_blank" rel="noopener noreferrer">
        <img
          src="https://influxerr.dyzio.co/images/influxerr-logo.png"
          height="60" alt="Influxer | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const IncastHeader = () => (
  <div>
    <h1>
      <a href="https://influencers.incast.us/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://influencers.incast.us/themes/theme/incast/incast-header-logo.png"
          height="80" alt="Incast | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const UploadHeader = () => (
  <div>
    <h1>
      <a href="https://creators.uploadagency.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://upload.dyzio.co/themes/theme/upload/upload-agency-wide.png"
          height="60" alt="Upload Agency | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const InspaceHeader = () => (
  <div>
    <h1>
      <a href="https://influencers.inspace.asia" target="_blank" rel="noopener noreferrer">
        <img
          src="https://inspacer.dyzio.co/images/inspacer-logo.png"
          height="60" alt="INSPACE | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const GiftaHeader = () => (
  <div>
    <h1>
      <a href="https://influencers.gifta.co.uk" target="_blank" rel="noopener noreferrer">
        <img
          src="https://influencers.gifta.co.uk/themes/theme/gifta/logo.png"
          height="70" alt="GIFTA | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const PulseHeader = () => (
  <div>
    <h1>
      <a href=" https://influencers.pulse.africa" target="_blank" rel="noopener noreferrer">
        <img
          src="https://pulser.dyzio.co/images/pulser-logo.png"
          height="70" alt="PULSE | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const InfluxcrowdHeader = () => (
  <div>
    <h1>
      <a href=" https://connect.influxcrowd.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://influxcrowdr.dyzio.co/images/influxcrowdr-logo.png"
          height="40" alt="INFLUXCROWD | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const FreeFolkHeader = () => (
  <div>
    <h1>
      <a href=" https://collaborations.freefolkagency.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://influxcrowdr.dyzio.co/images/freefolkr-logo.png"
          height="80" alt="FREEFOLK | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const BroadwayHeader = () => (
  <div>
    <h1>
      <a href=" https://collaborations.broadwaysocial.media" target="_blank" rel="noopener noreferrer">
        <img
          src="https://broadwayr.dyzio.co/images/broadwayr-logo.png"
          height="65" alt="BROADWAY SOCIAL | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const MoonBootsHeader = () => (
  <div>
    <h1>
      <a href=" https://campaigns.mymoonboots.io" target="_blank" rel="noopener noreferrer">
        <img
          src="https://moonbootsr.dyzio.co/images/moonbootsr-logo.png"
          height="80" alt="BROADWAY SOCIAL | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const ParentstarsHeader = () => (
  <div>
    <h1>
      <a href=" https://platform.parentstars.co.uk" target="_blank" rel="noopener noreferrer">
        <img
          src="https://platform.parentstars.co.uk/themes/theme/parentstars/logo.jpeg"
          height="60" alt="PARENT STARS | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const GenfluencerHeader = () => (
  <div>
    <h1>
      <a href="https://creators.genfluencer.io" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.genfluencer.io/themes/theme/genfluencer/genfluencer-logo.png"
          height="60" alt="PARENT STARS | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const MingoAppHeader = () => (
  <div>
    <h1>
      <a href="https://influencers.mingoapp.dk" target="_blank" rel="noopener noreferrer">
        <img
          src="https://influencers.mingoapp.dk/themes/theme/mingoApp/mingoApp-logo.png"
          height="60" alt="PARENT STARS | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const MecIncHeader = () => (
  <div>
    <h1>
      <a href="https://creators.mecinc.gg" target="_blank" rel="noopener noreferrer">
        <img
          src="https://share.dyzio.co/images/mecinc-logo.jpg"
          height="60" alt="Mec Inc. | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const FlytHeader = () => (
  <div>
    <h1>
      <a href="https://influencers.flytexperience.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://share.dyzio.co/images/flytr-logo.png"
          height="60" alt="Flyt | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const SnackHeader = () => (
  <div>
    <h1>
      <a href="https://creators.snackdrawer.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.snackdrawer.com/themes/theme/snackDrawer/logo.png"
          height="60" alt="Snack Drawer | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const GlobalMediaHeader = () => (
  <div>
    <h1>
      <a href="https://creators.global-media.gr/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.global-media.gr/themes/theme/global-media/GLOBAL-MEDIA-FINAL-LOGO_TRANSPARENT.png"
          height="60" alt="Global Media | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const RoomUnlockedHeader = () => (
  <div>
    <h1>
      <a href="https://creators.roomunlocked.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://reports.roomunlocked.com/images/the-room-small.png"
          height="70" alt="Room Unlocked | CAMPAIGNS"
          style={{paddingBottom: '10px'}}
        />
      </a>
    </h1>
  </div>
);

const TheInfluenceRoomHeader = () => (
  <div>
    <h1>
      <a href="https://creators.theinfluenceroom.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://reports.theinfluenceroom.com/images/the-room-small.png"
          height="70" alt="The Influence Room | CAMPAIGNS"
          style={{paddingBottom: '10px'}}
        />
      </a>
    </h1>
  </div>
);

const SendyHeader = () => (
  <div>
    <h1>
      <a href="https://senders.sendy.io/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://senders.sendy.io/themes/theme/sendy/logo.webp"
          height="60" alt="Sendy | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const AbbottLyonHeader = () => (
  <div>
    <h1>
      <a href="https://collaborators.abbottlyon.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://collaborators.abbottlyon.com/themes/theme/abbottlyon/logo.png"
          height="60" alt="Abbott Lyon | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const MonumentalHeader = () => (
  <div>
    <h1>
      <a href="https://creators.monumentalmarketing.co.uk/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.monumentalmarketing.co.uk/themes/theme/monumental/logo.png"
          height="40" alt="Monumental | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const ToptrumpsHeader = () => (
  <div>
    <h1>
      <a href="https://creators.toptrumps.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.toptrumps.com/themes/theme/toptrumps/logo.svg"
          height="60" alt="Top Trumps | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const EmbellishedlondonHeader = () => (
  <div>
    <h1>
      <a href="https://creators.embellishedlondon.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.embellishedlondon.com/themes/theme/embellishedlondon/logo.png"
          height="60" alt="Embellished London | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const WefluensHeader = () => (
  <div>
    <h1>
      <a href="https://creators.wefluens.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.wefluens.com/themes/theme/wefluens/wefluens.png"
          height="60" alt="Wefluens | CAMPAIGNS"
        />
      </a>
    </h1>
  </div>
);

const ShopfluenceHeader = () => (
  <div>
    <h1>
      <a href="https://www.shopfluence.app/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://share.dyzio.co/images/shopfluence-small.png"
          height="100" alt="SHOPFLUENCE"
        />
      </a>
    </h1>
  </div>
);

const StarBoxHeader = () => (
  <div>
    <h1>
      <a href="https://creators.starbox.co.uk/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.starbox.co.uk/themes/theme/starbox/logo.png"
          height="70" alt="STARBOX"
        />
      </a>
    </h1>
  </div>
);

const SehoHeader = () => (
  <div>
    <h1>
      <a href="https://seho.app/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://app.dyzio.co/themes/theme/seho/logo.png"
          height="50" alt="SEHO"
        />
      </a>
    </h1>
  </div>
);

const CampfireHeader = () => (
  <div>
    <h1>
      <a href="https://creators.campfire.co.uk/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.campfire.co.uk/themes/theme/campfire/logo.png"
          height="50" alt="CAMPFIRE"
        />
      </a>
    </h1>
  </div>
);

const ElemisHeader = () => (
  <div>
    <h1>
      <a href="https://creators.elemis.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://creators.elemis.com/themes/theme/elemis/logo.png"
          height="50" alt="Elemis"
        />
      </a>
    </h1>
  </div>
);

const MSQHeader = () => (
  <div>
    <h1>
      <a href="m3labscreators.msqpartners.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://m3labscreators.msqpartners.com/themes/theme/msqsource/M3_Labs_Logo_Blue.png"
          height="50" alt="MSQ"
        />
      </a>
    </h1>
  </div>
);

const LangtonHeader = () => (
  <div>
    <h1>
      <a href="https://campaigns.langtonpr.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://campaigns.langtonpr.com/themes/theme/langton/logo.png"
          height="50" alt="Langton"
        />
      </a>
    </h1>
  </div>
);

const DreamLabHeader = () => (
  <div>
    <h1>
      <a href="https://campaigns.dreamlabstudio.co.uk" target="_blank" rel="noopener noreferrer">
        <img
          src="https://campaigns.dreamlabstudio.co.uk/themes/theme/dreamlab/logo.png"
          height="50" alt="Dream Lab"
        />
      </a>
    </h1>
  </div>
);

const ShellRimulaHeader = () => (
  <div>
    <h1>
      <a href="https://shellrimula.msqpartners.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://app.dyzio.co/themes/theme/shellrimula/logo.svg"
          height="50" alt="Shell Rimula"
        />
      </a>
    </h1>
  </div>
);

const WildFusionHeader = () => (
  <div>
    <h1>
      <a href="https://influencers.wildfusions.com/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://app.dyzio.co/themes/theme/wildfusion/logo.png"
          height="30" alt="Wild Fusion"
        />
      </a>
    </h1>
  </div>
);

const NovaiHeader = () => (
  <div>
    <h1>
      <a href="https://influencers.novaiinfluencer.ai/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://app.dyzio.co/themes/theme/novai/logo.svg"
          height="60" alt="Novai"
        />
      </a>
    </h1>
  </div>
);

const ScreenshotHeader = () => (
  <div>
    <h1>
      <a href="https://campaigns.screenshotmedia.co/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://app.dyzio.co/themes/theme/screenshot/logo.png"
          height="60" alt="Screenshot"
        />
      </a>
    </h1>
  </div>
);

let headerStyles = isDyzio ? {} : SKINS[SUBDOMAIN];
if (isVoxogram) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #df0098',
  };
}

const isBlue42Domain = domain => domain === GO_BLUE_42_DOMAIN;
const isCorqDomain = domain => domain === CORQ_DOMAIN;
const isDorchesterDomain = domain => domain === DORCHESTER_DOMAIN;
const isTheInfluencerDomain = domain => domain === THE_INFLUENCER_DOMAIN;
const isTheRoomDomain = domain => domain === THE_ROOM_DOMAIN;
const isSuforiaDomain = domain => domain === SUFORIA_DOMAIN;
const isStylistDomain = domain => domain === STYLIST_DOMAIN;
const isCpaDomain = domain => domain === CPA_DOMAIN;
const isBdsDomain = domain => domain === BDS_DOMAIN;
const isInfluxerDomain = domain => domain === INFLUXER_DOMAIN;
const isIncastDomain = domain => domain === INCAST_DOMAIN;
const isUploadDomain = domain => domain === UPLOAD_DOMAIN;
const isInspaceDomain = domain => domain === INSPACE_DOMAIN;
const isGiftaDomain = domain => domain === GIFTA_DOMAIN;
const isPulseDomain = domain => domain === PULSE_DOMAIN;
const isInfluxcrowdDomain = domain => domain === INFLUXCROWD_DOMAIN;
const isFreefolkDomain = domain => domain === FREEFOLK_DOMAIN;
const isBroadwayDomain = domain => domain === BROADWAY_DOMAIN;
const isMoonbootsDomain = domain => domain === MOONBOOTS_DOMAIN;
const isParentstarsDomain = domain => domain === PARENTSTARS_DOMAIN;
const isGenfluencerDomain = domain => domain === GENFLUENCER_DOMAIN;
const isMingoAppDomain = domain => domain === MINFLU_DOMAIN;
const isMecIncDomain = domain => domain === MECINC_DOMAIN;
const isFlytDomain = domain => domain === FLYT_DOMAIN;
const isSnackDomain = domain => domain === SNACKDRAWER_DOMAIN;
const isGlobalMediaDomain = domain => domain === GLOBALMEDIA_DOMAIN;
const isRoomUnlockedDomain = domain => domain === ROOMUNLOCKED_DOMAIN;
const isSendyDomain = domain => domain === SENDY_DOMAIN;
const isAbbottLyonDomain = domain => domain === ABBOTTLYON_DOMAIN;
const isMonumentalDomain = domain => domain === MONUMENTAL_DOMAIN;
const isToptrumpsDomain = domain => domain === TOPTRUMPS_DOMAIN;
const isEmbellishedlondonDomain = domain => domain === EMBELLISHEDLONDON_DOMAIN;
const isTheInfluenceRoomDomain = domain => domain === THEINFLUENCEROOM_DOMAIN;
const isWefluensDomain = domain => domain === WEFLUENS_DOMAIN;
const isShopfluenceDomain = domain => domain === SHOPFLUENCE_DOMAIN;
const isStarBoxDomain = domain => domain === STARBOX_DOMAIN;
const isSehoDomain = domain => domain === SEHO_DOMAIN;
const isCampfireDomain = domain => domain === CAMPFIRE_DOMAIN;
const isElemisDomain = domain => domain === ELEMIS_DOMAIN;
const isMSQDomain = domain => domain === MSQ_DOMAIN;
const isLangtonDomain = domain => domain === LANGTON_DOMAIN;
const isDreamLabDomain = domain => domain === DREAMLAB_DOMAIN;
const isShellRimulaDomain = domain => domain === SHELLRIMULA_DOMAIN;
const isWildFusionDomain = domain => domain === WILDFUSION_DOMAIN;
const isNovaiDomain = domain => domain === NOVAI_DOMAIN;
const isScreenshotDomain = domain => domain === SCREENSHOT_DOMAIN;

const isBlue42 = isBlue42Domain(hostname);
const isCorq = isCorqDomain(hostname);
const isDorchester = isDorchesterDomain(hostname);
const isTheInfluencer = isTheInfluencerDomain(hostname);
const isTheRoom = isTheRoomDomain(hostname);
const isSuforia = isSuforiaDomain(hostname);
const isStylist = isStylistDomain(hostname);
const isCPA = isCpaDomain(hostname);
const isBds = isBdsDomain(hostname);
const isInfluxer = isInfluxerDomain(hostname);
const isIncast = isIncastDomain(hostname);
const isUpload = isUploadDomain(hostname);
const isInspace = isInspaceDomain(hostname);
const isGifta = isGiftaDomain(hostname);
const isPulse = isPulseDomain(hostname);
const isInfluxcrowd = isInfluxcrowdDomain(hostname);
const isFreefolk = isFreefolkDomain(hostname);
const isBroadway = isBroadwayDomain(hostname);
const isMoonboots = isMoonbootsDomain(hostname);
const isParentstars = isParentstarsDomain(hostname);
const isGenfluencer = isGenfluencerDomain(hostname);
const isMingoApp = isMingoAppDomain(hostname);
const isMecInc = isMecIncDomain(hostname);
const isFlyt = isFlytDomain(hostname);
const isSnack = isSnackDomain(hostname);
const isGlobalMedia = isGlobalMediaDomain(hostname);
const isRoomUnlocked = isRoomUnlockedDomain(hostname);
const isSendy = isSendyDomain(hostname);
const isAbbottLyon = isAbbottLyonDomain(hostname);
const isMonumental = isMonumentalDomain(hostname);
const isToptrumps = isToptrumpsDomain(hostname);
const isEmbellishedlondon = isEmbellishedlondonDomain(hostname);
const isTheInfluenceRoom = isTheInfluenceRoomDomain(hostname);
const isWefluens = isWefluensDomain(hostname);
const isShopfluence = isShopfluenceDomain(hostname);
const isStarBox = isStarBoxDomain(hostname);
const isSeho = isSehoDomain(hostname);
const isCampfire = isCampfireDomain(hostname);
const isElemis = isElemisDomain(hostname);
const isMSQ = isMSQDomain(hostname);
const isLangton = isLangtonDomain(hostname);
const isDreamLab = isDreamLabDomain(hostname);
const isShellRimula = isShellRimulaDomain(hostname);
const isWildFusion = isWildFusionDomain(hostname);
const isNovai = isNovaiDomain(hostname);
const isScreenshot = isScreenshotDomain(hostname);

if (isBlue42) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
    textAlign: 'center',
    height: 120,
  };
}

if (isCorq) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
    height: 90,
  };
}

if (isTheInfluencer) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
    height: 90,
  };
}

if (isDorchester) {
  headerStyles = {
    backgroundColor: '#000',
    borderBottom: '2px solid #000',
    height: 80,
  };
}

if (isTheRoom) {
  headerStyles = {
    backgroundColor: '#002a5a',
    borderBottom: '5px solid #000',
    height: 90,
  };
}

if (isSuforia) {
  headerStyles = {
    backgroundColor: '#211e1e',
    borderBottom: '2px solid #000',
    height: 90,
  };
}

if (isStylist) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '3px solid #3dd2be',
    height: 85,
  };
}

if (isCPA) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '3px solid #001F5B',
    height: 80,
  };
}

if (isBds) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #A0CC3A',
    height: 80,
  };
}

if (isInfluxer) {
  headerStyles = {
    backgroundColor: '#000',
    borderBottom: '2px solid #000',
    height: 80,
  };
}

if (isIncast) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #000',
    height: 80,
    padding: 0,
  };
}

if (isUpload) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '2px solid rgb(239, 42, 48)',
    height: 70,
    padding: 0,
  };
}

if (isInspace) {
  headerStyles = {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #FEC909',
    height: 60,
  };
}

if (isGifta) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 60,
  };
}

if (isPulse) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #AB2923',
    height: 80,
  };
}

if (isInfluxcrowd) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #ED0444',
    height: 80,
  };
}

if (isFreefolk) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #37AAFA',
    height: 100,
  };
}

if (isBroadway) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #d472c3',
    height: 80,
  };
}

if (isMoonboots) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #000000',
    height: 80,
  };
}

if (isParentstars) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #302c6b',
    height: 80,
  };
}

if (isGenfluencer) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #CCFF33',
    height: 80,
  };
}

if (isMingoApp) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid  #03A8C2',
    height: 80,
  };
}

if (isMecInc) {
  headerStyles = {
    backgroundColor: '#000',
    borderBottom: '4px solid  #000',
    height: 80,
  };
}

if (isFlyt) {
  headerStyles = {
    backgroundColor: '#272727',
    borderBottom: '4px solid #272727',
    height: 80,
  };
}

if (isSnack) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #6c5543',
    height: 80,
  };
}

if (isGlobalMedia) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #474648',
    height: 80,
  };
}

if (isRoomUnlocked) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #0b1919',
    height: 80,
  };
}

if (isTheInfluenceRoom) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #0b1919',
    height: 80,
  };
}

if (isSendy) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #002a5a',
    height: 80,
  };
}

if (isAbbottLyon) {
  headerStyles = {
    backgroundColor: '#EEDDD5',
    borderBottom: '2px solid #FDF5ED',
    height: 80,
  };
}

if (isMonumental) {
  headerStyles = {
    backgroundColor: '#F2E3AB',
    borderBottom: '2px solid #F2E3AB',
    height: 80,
  };
}

if (isToptrumps) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #268ce3',
    height: 80,
  };
}

if (isEmbellishedlondon) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #ee1090',
    height: 80,
  };
}

if (isWefluens) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #DA1F59',
    height: 80,
  };
}

if (isShopfluence) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #fc4085',
    height: 100,
  };
}

if (isStarBox) {
  headerStyles = {
    backgroundColor: '#000',
    borderBottom: '2px solid #000',
    height: 100,
  };
}

if (isSeho) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #2683EF',
    height: 60,
  };
}

if (isCampfire) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #fbbd4b',
    height: 70,
  };
}

if (isElemis) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #000',
    height: 70,
  };
}

if (isMSQ) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #0000eb',
    height: 70,
  };
}

if (isLangton) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #FF0000',
    height: 70,
  };
}

if (isDreamLab) {
  headerStyles = {
    backgroundColor: '#000',
    borderBottom: '2px solid #000',
    height: 70,
  };
}

if (isShellRimula) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '2px solid #e5001d',
    height: 70,
  };
}

if (isWildFusion) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #326598',
    height: 80,
  };
}

if (isNovai) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #0000',
    height: 80,
  };
}

if (isScreenshot) {
  headerStyles = {
    backgroundColor: '#fff',
    borderBottom: '4px solid #000',
    height: 80,
  };
}

let pageTitle = 'dyzio';
pageTitle = isVoxogram ? 'voxogram' : pageTitle;
pageTitle = isCorq ? 'CORQ' : pageTitle;
pageTitle = isTheInfluencer ? 'Content Club' : pageTitle;
pageTitle = isTheRoom ? 'THE ROOM' : pageTitle;
pageTitle = isSuforia ? 'SUFORIA' : pageTitle;
pageTitle = isStylist ? 'THE STYLIST' : pageTitle;
pageTitle = isCPA ? 'CROWDPOINT ANALYTICS' : pageTitle;
pageTitle = isBds ? 'BRANDFLUENCERS' : pageTitle;
pageTitle = isInfluxer ? 'INFLUXER' : pageTitle;
pageTitle = isIncast ? 'INCAST' : pageTitle;
pageTitle = isUpload ? 'UPLOAD AGENCY' : pageTitle;
pageTitle = isInspace ? 'INSPACE' : pageTitle;
pageTitle = isGifta ? 'GIFTA' : pageTitle;
pageTitle = isPulse ? 'PULSE' : pageTitle;
pageTitle = isInfluxcrowd ? 'INFLUXCROWD' : pageTitle;
pageTitle = isFreefolk ? 'FREEFOLK' : pageTitle;
pageTitle = isBroadway ? 'BROADWAY SOCIAL' : pageTitle;
pageTitle = isMoonboots ? 'MOON BOOTS' : pageTitle;
pageTitle = isParentstars ? 'PARENT STARS' : pageTitle;
pageTitle = isGenfluencer ? 'Genfluencer' : pageTitle;
pageTitle = isMingoApp ? 'MINFLU' : pageTitle;
pageTitle = isMecInc ? 'Mec Inc.' : pageTitle;
pageTitle = isFlyt ? 'Flyt' : pageTitle;
pageTitle = isSnack ? 'Snack Drawer' : pageTitle;
pageTitle = isGlobalMedia ? 'Global Media' : pageTitle;
pageTitle = isRoomUnlocked ? 'Room Unlocked' : pageTitle;
pageTitle = isSendy ? 'Sendy' : pageTitle;
pageTitle = isAbbottLyon ? 'Abbott Lyon' : pageTitle;
pageTitle = isMonumental ? 'Monumental' : pageTitle;
pageTitle = isToptrumps ? 'Top Trumps' : pageTitle;
pageTitle = isEmbellishedlondon ? 'Embellished London' : pageTitle;
pageTitle = isTheInfluenceRoom ? 'The Influence Room' : pageTitle;
pageTitle = isWefluens ? 'Wefluens' : pageTitle;
pageTitle = isShopfluence ? 'SHOPFLUENCE' : pageTitle;
pageTitle = isStarBox ? 'STARBOX' : pageTitle;
pageTitle = isSeho ? 'SEHO' : pageTitle;
pageTitle = isCampfire ? 'CAMPFIRE' : pageTitle;
pageTitle = isElemis ? 'ELEMIS' : pageTitle;
pageTitle = isMSQ ? 'MSQ' : pageTitle;
pageTitle = isLangton ? 'LANGTON' : pageTitle;
pageTitle = isDreamLab ? 'DREAM LAB' : pageTitle;
pageTitle = isShellRimula ? 'SHELL RIMULA' : pageTitle;
pageTitle = isWildFusion ? 'WILD FUSION' : pageTitle;
pageTitle = isNovai ? 'NOVAI' : pageTitle;
pageTitle = isScreenshot ? 'SCREENSHOT' : pageTitle;

const HeaderComponent = ({ hostname }) => {
  if (hostname === 'app.voxogram.com') return (<VoxogramHeader />);
  if (isBlue42Domain(hostname)) return (<GB42Header />);
  if (isCorqDomain(hostname)) return (<CorqHeader />);
  if (isDorchesterDomain(hostname)) return (<DorchesterHeader />);
  if (isTheInfluencerDomain(hostname)) return (<TheInfluencerHeader />);
  if (isTheRoomDomain(hostname)) return (<TheRoomHeader />);
  if (isSuforiaDomain(hostname)) return (<SuforiaHeader />);
  if (isStylistDomain(hostname)) return (<StylistHeader />);
  if (isCpaDomain(hostname)) return (<CpaHeader />);
  if (isBdsDomain(hostname)) return (<BdsHeader />);
  if (isInfluxerDomain(hostname)) return (<InfluxerHeader />);
  if (isIncastDomain(hostname)) return (<IncastHeader />);
  if (isUploadDomain(hostname)) return (<UploadHeader />);
  if (isInspaceDomain(hostname)) return (<InspaceHeader />);
  if (isGiftaDomain(hostname)) return (<GiftaHeader />);
  if (isPulseDomain(hostname)) return (<PulseHeader />);
  if (isInfluxcrowdDomain(hostname)) return (<InfluxcrowdHeader />);
  if (isFreefolkDomain(hostname)) return (<FreeFolkHeader />);
  if (isBroadwayDomain(hostname)) return (<BroadwayHeader />);
  if (isMoonbootsDomain(hostname)) return (<MoonBootsHeader />);
  if (isParentstarsDomain(hostname)) return (<ParentstarsHeader />);
  if (isGenfluencerDomain(hostname)) return (<GenfluencerHeader />);
  if (isMingoAppDomain(hostname)) return (<MingoAppHeader />);
  if (isMecIncDomain(hostname)) return (<MecIncHeader />);
  if (isFlytDomain(hostname)) return (<FlytHeader />);
  if (isSnackDomain(hostname)) return (<SnackHeader />);
  if (isGlobalMediaDomain(hostname)) return (<GlobalMediaHeader />);
  if (isRoomUnlockedDomain(hostname)) return (<RoomUnlockedHeader />);
  if (isSendyDomain(hostname)) return (<SendyHeader />);
  if (isAbbottLyonDomain(hostname)) return (<AbbottLyonHeader />);
  if (isMonumentalDomain(hostname)) return (<MonumentalHeader />);
  if (isToptrumpsDomain(hostname)) return (<ToptrumpsHeader />);
  if (isEmbellishedlondonDomain(hostname)) return (<EmbellishedlondonHeader />);
  if (isTheInfluenceRoomDomain(hostname)) return (<TheInfluenceRoomHeader />);
  if (isWefluensDomain(hostname)) return (<WefluensHeader />);
  if (isShopfluenceDomain(hostname)) return (<ShopfluenceHeader />);
  if (isStarBoxDomain(hostname)) return (<StarBoxHeader />);
  if (isSehoDomain(hostname)) return (<SehoHeader />);
  if (isCampfireDomain(hostname)) return (<CampfireHeader />);
  if (isElemisDomain(hostname)) return (<ElemisHeader />);
  if (isMSQDomain(hostname)) return (<MSQHeader />);
  if (isLangtonDomain(hostname)) return (<LangtonHeader />);
  if (isDreamLabDomain(hostname)) return (<DreamLabHeader />);
  if (isShellRimulaDomain(hostname)) return (<ShellRimulaHeader />);
  if (isWildFusionDomain(hostname)) return (<WildFusionHeader />);
  if (isNovaiDomain(hostname)) return (<NovaiHeader />);
  if (isScreenshotDomain(hostname)) return (<ScreenshotHeader />);
  return (<ShareHeader />);
};

if (isTheInfluencer) import('./the-influencer.css').then(console.log('imported the influencer CSS'));

const App = () => (
  <Router>
    <Container>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageTitle} | sharing</title>
      </Helmet>
      <header id="page-header" style={headerStyles}>
        <div className="inner">
          <HeaderComponent hostname={hostname} />
        </div>
      </header>
      <div id="page-content">
        <Route exact path="/" component={Home} />
        <Route path="/super-report/:campaignCode" component={SuperReport} />
        <Route path="/report/:id/:type/:dayFilterValue?" component={Report} />
        <Route path="/collab/:id/:type/:dayFilterValue?" component={Report} />
        <Route path="/reportview/:id/" component={ReportView} />
        <Route path="/stories/:campaignId" component={StoriesReport} />
        <Route path="/shortlists3" component={ShortlistsV3} />
        <Route path="/shortlists2" component={ShortlistsV2} />
        <Route path="/shortlists" component={Shortlists} />
        <Route path="/ext/shortlists" component={Shortlists} />
        <Route path="/reports/:name" component={CampaignReport} />
        <Route path="/reportsv2/:name" component={CampaignReport2} />
        <Route path="/profile/:id" component={Profile} />
        <Route path="/influencer/:id/summary" component={Summary} />
        <Route path="/profiles" component={ProfileList} />
        <Route path="/corq" component={CorqLogin} />
      </div>
      {!isGifta && <footer id="page-footer">
        <div>
          {
            isDyzio &&
            <p style={tcStyles}>
              By using this site you agree to our
              &nbsp;<a target="_blank" rel="noopener noreferrer" href={termsAndConditionsLink}>
              Terms and Conditions</a> | © Dyzio Ltd. All rights reserved.
            </p>
          }
        </div>
      </footer>}
    </Container>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js